module.exports = __webpack_public_path__ + "media/images/icon-4-51d45212e142894f9f2886e62a9a8b75.png";